import React from 'react';
import warningIcon from '../../assests/images/warning.png';
import './CustomDeleteConfirmationModal.css';
import { useTranslation } from 'react-i18next';
import Lottie from 'lottie-react';
import deleteAnimation from '../../assests/images/Animations/deleteAnimation.json';
import closeAnimation from '../../assests/images/Animations/closeAnimation.json';
import openAnimation from '../../assests/images/Animations/OpenMonth.json';
import sendReportAnimation from '../../assests/images/Animations/sendReport.json';

const CustomDeleteConfirmationModal = ({ isVisible, onClose, onDelete, confirmMessage, confirmValues, titleMessage, type, isProcessing }) => {
    const { t } = useTranslation();
    if (!isVisible) return null;

    const handleBackdropClick = (e) => {
        onClose();
    };

    const handleModalClick = (e) => {
        // Prevents the click from bubbling up to the backdrop
        e.stopPropagation();
    };

    const getAnimation = () => {
        switch (type) {
            case 'closeMonth':
                return closeAnimation;
            case 'openMonth':
                return openAnimation;
            case 'sendReport':
            case 'VatReport':
                return sendReportAnimation;
            default:
                return deleteAnimation;
        }
    };

    // Conditional styles
    const isGreenType = type === 'openMonth' || type === 'sendReport' || type === 'VatReport';
    const modalTitleStyle = isGreenType ? { color: '#2CD852' } : {};
    const okButtonClass = isGreenType ? 'ok-button-green' : '';

    return (
        <div className="modal-backdrop" onClick={handleBackdropClick} style={{ zIndex: 3000 }}>
            <div className="modal" onClick={handleModalClick}>
                <Lottie
                    animationData={getAnimation()}
                    loop={true}
                    style={{ height: 188, width: 188, margin: '0 auto' }}
                />
                <h2 className="modal-title" style={modalTitleStyle}>
                    {t(titleMessage) || t('confirmDeleteTitle')}
                </h2>
                <p className="modal-message">
                    {confirmMessage
                        ? t(confirmMessage, confirmValues)
                        : t('confirmDeleteMessage')}
                </p>
                <div className="modal-button-container">
                    <button type="button" onClick={onClose} className="cancel-button" disabled={isProcessing}>{t('cancelButton')}</button>
                    <button type="button" onClick={onDelete} className={`ok-button ${okButtonClass}`} disabled={isProcessing}>
                        {t('okButton')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomDeleteConfirmationModal;
